// Mesma fórmula de margem usada na Calculadora (useCalculadora.ts:
// margemTabela = 1 - custoNaMoedaTabela / tabela.precoNet), reaproveitada
// aqui pra Tabela de Preços não divergir do que a Calculadora mostra pro
// mesmo cliente+produto.

export type Moeda = 'BRL' | 'USD' | 'EUR';

export function exchangeRate(moeda: string, usd: number, eur: number): number {
  return moeda === 'USD' ? usd : moeda === 'EUR' ? eur : 1;
}

export type StatusMargem = 'verde' | 'amarelo' | 'vermelho';

export function marginStatus(precoVendaKg: number | null, margem: number | null): StatusMargem {
  if (precoVendaKg === null || margem === null || !Number.isFinite(precoVendaKg) || !Number.isFinite(margem)) return 'vermelho';
  if (precoVendaKg < 1.99) {
    if (margem < 0.30) return 'vermelho';
    if (margem < 0.36) return 'amarelo';
    return 'verde';
  }
  if (precoVendaKg >= 5 && margem >= 0.22) return 'verde';
  if (precoVendaKg >= 4 && margem >= 0.25) return 'verde';
  if (precoVendaKg >= 3 && margem >= 0.30) return 'verde';
  if (precoVendaKg >= 2 && margem >= 0.37) return 'verde';
  if (precoVendaKg < 2 && margem >= 0.37) return 'verde';
  return 'vermelho';
}

export interface PrecoDerivados {
  precoVendaKg: number | null;
  margem: number | null;
  statusMargem: StatusMargem;
}

/** custoReposicao vem sempre em BRL (padrão do cadastro de materiais). */
export function computePrecoDerivados(
  precoNet: number,
  moeda: string,
  custoReposicaoBrl: number | undefined,
  cotacaoUsd: number,
  cotacaoEur: number,
): PrecoDerivados {
  if (custoReposicaoBrl === undefined || precoNet <= 0) {
    return { precoVendaKg: null, margem: null, statusMargem: 'vermelho' };
  }
  const cambio = exchangeRate(moeda, cotacaoUsd, cotacaoEur) || 1;
  const custoNaMoeda = custoReposicaoBrl / cambio;
  const margem = 1 - custoNaMoeda / precoNet;
  const precoVendaKg = precoNet * cambio;
  return { precoVendaKg, margem, statusMargem: marginStatus(precoVendaKg, margem) };
}
